/**
 * Date Utilities
 * This module provides utilities for managing date-related operations.
 */

/**
 * @description Function to calculate the age from a date string
 * @param dateString - The date string to format
 * @return {number} Age in years
 */
export const getAge = (dateString: string): number => {
  const today = new Date()
  const birthDate = new Date(dateString)
  let age = today.getFullYear() - birthDate.getFullYear()
  const m = today.getMonth() - birthDate.getMonth()
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--
  }
  return age
}
